
    <!--
 * 横版-全局弹窗
 * @LastEditTime: Mon Feb 17 2025 18:24:03 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_3AAA17"  :class="[`normal`,`u_c_3AAA17`]" ><div id="u_c_YLOM18"  v-show="compData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup bind-popup`,`u_c_YLOM18`]" @click="u_c_YLOM18_event_F8M123($event)"><div id="u_c_EZ8J19"  :class="[`normal popup-content-small`,`u_c_EZ8J19`]" @click="u_c_EZ8J19_event_2MZ224($event)"><div id="u_c_DDUR20"  :class="[`normal popup-title popup-title-color`,`u_c_DDUR20`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_B11P22"  :class="[`normal`,`u_c_B11P22`]" ><div id="u_c_DCJ823"  :class="[`normal select-item `,`u_c_DCJ823`]" ><select id="u_c_9I0S24"  v-model="pageData.serverItem" :class="[`normal select-item-select  server-select`,`u_c_9I0S24`]" ><option id="u_c_YB6125" disabled="disabled" :value="defaultServerItem" :class="[`normal`,`u_c_YB6125`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_5WSH27"  :label="langData.yourServer" :class="[`normal`,`u_c_5WSH27`]" ><option id="u_c_DI5W28"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_DI5W28`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_DTZ430"  :label="langData.allServer" :class="[`normal`,`u_c_DTZ430`]" ><option id="u_c_BL6L31"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal`,`u_c_BL6L31`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_0BRZ33"  :class="[`normal select-item`,`u_c_0BRZ33`]" ><select id="u_c_6MFN34"  v-model="pageData.roleIndex" :class="[`normal select-item-select `,`u_c_6MFN34`]" ><option id="u_c_X5WC35"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal`,`u_c_X5WC35`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_DKO437" href="javascript:;" :class="[`normal sure submit-bind`,`u_c_DKO437`]" @click="u_c_DKO437_event_QSVC19($event)">{{`${ langData.bindBtn }`}}</a><div id="u_c_784339"  v-html="langData.canNoReBind" v-show="!pageData.canReBind" :class="[`normal txt-size tips-color`,`u_c_784339`]" ></div><a id="u_c_4AAC40" href="javascript:;" :class="[`normal popup-close bind-popup-close`,`u_c_4AAC40`]" @click="u_c_4AAC40_event_DMX517($event)"></a></div></div><div id="u_c_B7PH41"  v-show="compData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup bag-popup`,`u_c_B7PH41`]" @click="u_c_B7PH41_event_F8M123($event)"><div id="u_c_37AZ42"  :class="[`normal popup-content-big`,`u_c_37AZ42`]" @click="u_c_37AZ42_event_2MZ224($event)"><div id="u_c_YV9L43"  :class="[`normal popup-title popup-title-color`,`u_c_YV9L43`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_AJEN45"  :class="[`normal border-color`,`u_c_AJEN45`]" ><table id="u_c_FFLM46"  :class="[`normal`,`u_c_FFLM46`]" ><thead id="u_c_7SYQ47"  :class="[`normal`,`u_c_7SYQ47`]" ><td id="u_c_DR2P48"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_DR2P48`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_4DR950"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_4DR950`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_3MAG52"  :class="[`normal`,`u_c_3MAG52`]" ><tr id="u_c_V45S53"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :class="[`normal border-color tr  bag-popup-content-item`,`u_c_V45S53`]" ><td id="u_c_6VDD54"  :class="[`normal td border-color txt-size txt-color time`,`u_c_6VDD54`]" >{{`${ packItem.award_time }`}}</td><td id="u_c_5EJF56"  :class="[`normal td border-color txt-size txt-color`,`u_c_5EJF56`]" ><span id="u_c_EGHL57"  v-html="packItem.award_name || giftInfo[packItem.award_block] && giftInfo[packItem.award_block][+packItem.send_id - 1] && giftInfo[packItem.award_block][+packItem.send_id - 1].name || ''" :class="[`normal`,`u_c_EGHL57`]" ></span><span id="u_c_0P5L58"  v-html="`${ langData.giftCode }：${ packItem.award_code }`" v-show="packItem.send_type == 'sendSerial'" :class="[`normal award-code`,`u_c_0P5L58`]" ></span><a id="u_c_7LGZ59" href="javascript:;" v-show="packItem['send_type'] == 'sendCoupon'" :class="[`normal popup-title-color txt-size use-quan`,`u_c_7LGZ59`]" @click="u_c_7LGZ59_event_1JVM17($event)">{{`[${ langData.useBtn }]`}}</a><a id="u_c_6YH561" href="javascript:;" v-show="packItem['send_type'] == 'sendSerial'" :class="[`normal txt-size popup-title-color
use-award-code`,`u_c_6YH561`]" @click="u_c_6YH561_event_QX7K17($event,packItem.award_code)">{{`[${ langData.copyAndGoExchange }]`}}</a></td></tr></tbody></table><div id="u_c_A18C63"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_A18C63`]" ></div></div><a id="u_c_207I64" href="javascript:;" :class="[`normal popup-close bag-popup-close`,`u_c_207I64`]" @click="u_c_207I64_event_DMX517($event)"></a></div></div><div id="u_c_9Z7B65"  v-show="compData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup`,`u_c_9Z7B65`]" @click="u_c_9Z7B65_event_TETB35($event)"><div id="u_c_F5DD66"  :class="[`normal popup-content-small`,`u_c_F5DD66`]" @click="u_c_F5DD66_event_U82518($event)"><div id="u_c_V98X67"  :class="[`normal popup-title-color popup-title`,`u_c_V98X67`]" >{{`${ pageData.tips }`}}</div><a id="u_c_CV5E69" href="javascript:;" :class="[`normal sure`,`u_c_CV5E69`]" @click="u_c_CV5E69_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_8L7W71" href="javascript:;" :class="[`normal popup-close`,`u_c_8L7W71`]" @click="u_c_8L7W71_event_DMX517($event)"></a></div></div><div id="u_c_VRJF72"  v-show="compData.previewPopup == 'previewGift' || pageData.seeGiftPopupState" :class="[`normal popup award-popup`,`u_c_VRJF72`]" @click="u_c_VRJF72_event_TETB35($event)"><div id="u_c_6HXR73"  :class="[`normal popup-content-small`,`u_c_6HXR73`]" @click="u_c_6HXR73_event_U82518($event)"><div id="u_c_UORR74"  :class="[`normal popup-title-color popup-title`,`u_c_UORR74`]" >{{`${ langData.checkGiftBtn }`}}</div><div id="u_c_8KE031"  :class="[`normal `,`u_c_8KE031`]" ><table id="u_c_87FO32"  :class="[`normal`,`u_c_87FO32`]" ><tbody id="u_c_PR8033"  :class="[`normal`,`u_c_PR8033`]" ><tr id="u_c_CZYQ34"  v-for="(seeItem, seeIndex) in pageData.seeGift" :key="seeIndex" :class="[`normal border-color  tr  award-popup-content`,`u_c_CZYQ34`]" ><td id="u_c_EDXO35"  :class="[`normal td border-color txt-size txt-color`,`u_c_EDXO35`]" ><img id="u_c_BVS636"  :src="seeItem.pic" v-show="seeItem.pic" :class="[`normal award-popup-content-img`,`u_c_BVS636`]" /></td><td id="u_c_NLX637"  :class="[`normal td border-color txt-size txt-color`,`u_c_NLX637`]" ><div id="u_c_NWC738"  v-html="seeItem.name" :class="[`normal award-popup-content-text`,`u_c_NWC738`]" ></div></td></tr></tbody></table></div><a id="u_c_A47S77" href="javascript:;" :class="[`normal popup-close award-popup-close`,`u_c_A47S77`]" @click="u_c_A47S77_event_DMX517($event)"></a></div></div><div id="u_c_5CEN78"  v-show="compData.previewPopup == 'daoju' || pageData.propsPopupState" :class="[`normal popup sendVt-popup`,`u_c_5CEN78`]" @click="u_c_5CEN78_event_TETB35($event)"><div id="u_c_B8SU79"  :class="[`normal popup-content-big`,`u_c_B8SU79`]" @click="u_c_B8SU79_event_U82518($event)"><div id="u_c_DY3E80"  :class="[`normal popup-title popup-title-color`,`u_c_DY3E80`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_1U1082"  :class="[`normal`,`u_c_1U1082`]" ><div id="u_c_3XQE83"  :class="[`normal`,`u_c_3XQE83`]" ><div id="u_c_F0U284"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color award-text`,`u_c_F0U284`]" ></div></div><img id="u_c_Z47085"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal award-img`,`u_c_Z47085`]" /></div><a id="u_c_AYE286" href="javascript:;" :class="[`normal sure`,`u_c_AYE286`]" @click="u_c_AYE286_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_AY1I88"  v-html="langData.daojuTips" :class="[`normal tips-color txt-size`,`u_c_AY1I88`]" ></div><a id="u_c_612G89" href="javascript:;" :class="[`normal popup-close sendVt-popup-close`,`u_c_612G89`]" @click="u_c_612G89_event_DMX517($event)"></a></div></div><div id="u_c_6QX790"  v-show="compData.previewPopup == 'youhuiquan' || pageData.quanPopupState" :class="[`normal popup sendCoupon-popup`,`u_c_6QX790`]" @click="u_c_6QX790_event_TETB35($event)"><div id="u_c_D5F091"  :class="[`normal popup-content-big`,`u_c_D5F091`]" @click="u_c_D5F091_event_U82518($event)"><div id="u_c_60LO92"  :class="[`normal popup-title popup-title-color`,`u_c_60LO92`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_XYU694"  :class="[`normal`,`u_c_XYU694`]" ><div id="u_c_5JF295"  :class="[`normal`,`u_c_5JF295`]" ><div id="u_c_EQXC96"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color award-text`,`u_c_EQXC96`]" ></div></div><img id="u_c_V4J897"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal award-img`,`u_c_V4J897`]" /></div><a id="u_c_XNP598" href="javascript:;" :class="[`normal  sure use-quan`,`u_c_XNP598`]" @click="u_c_XNP598_event_35V252($event)">{{`${ langData.useBtn }`}}</a><a id="u_c_WXSX105" href="javascript:;" :class="[`normal popup-close sendCoupon-popup-close`,`u_c_WXSX105`]" @click="u_c_WXSX105_event_DMX517($event)"></a></div></div><div id="u_c_1RDB106"  v-show="compData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup sendSerial-popup`,`u_c_1RDB106`]" @click="u_c_1RDB106_event_TXZS38($event)"><div id="u_c_3KAF107"  :class="[`normal popup-content-small`,`u_c_3KAF107`]" @click="u_c_3KAF107_event_EKU139($event)"><div id="u_c_C3XY108"  :class="[`normal popup-title popup-title-color`,`u_c_C3XY108`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_4L93110"  :class="[`normal`,`u_c_4L93110`]" ><div id="u_c_29SD111"  :class="[`normal txt-size txt-color`,`u_c_29SD111`]" >{{`${ langData.giftCode }：`}}<span id="u_c_Z45Y23"  v-html="pageData.curGiftName" :class="[`normal award-code`,`u_c_Z45Y23`]" ></span></div><a id="u_c_AWGX113" href="javascript:;" :class="[`normal txt-size popup-title-color`,`u_c_AWGX113`]" @click="u_c_AWGX113_event_QX7K17($event)">{{`[${ langData.copy }]`}}</a></div><div id="u_c_237H115" href="javascript:;" :class="[`${ compData.copyTipsState ? '' : 'hide' }`,`normal txt-size txt-color`,`u_c_237H115`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_08YN117" href="javascript:;" :class="[`normal popup-close sendSerial-popup-close`,`u_c_08YN117`]" @click="u_c_08YN117_event_KBHJ41($event)"></a><a id="u_c_9GXE118" href="javascript:;" :class="[`normal sure use-award-code`,`u_c_9GXE118`]" @click="u_c_9GXE118_event_YU9U68($event)">{{`${ langData.gotoExchange }`}}</a></div></div><div id="u_c_B8W2120"  v-show="compData.previewPopup == 'info' || pageData.infoPopupState" :class="[`normal popup info-popup`,`u_c_B8W2120`]" @click="u_c_B8W2120_event_TETB35($event)"><div id="u_c_85YY121"  :class="[`normal popup-content-big`,`u_c_85YY121`]" @click="u_c_85YY121_event_U82518($event)"><div id="u_c_CU24122"  :class="[`normal popup-title popup-title-color`,`u_c_CU24122`]" >{{`${ langData.infoBtn }`}}</div><div id="u_c_8739124"  v-html="compData.infoContent" :class="[`normal txt-size txt-color info-popup-content`,`u_c_8739124`]" ></div><a id="u_c_W64O125" href="javascript:;" :class="[`normal popup-close info-popup-close`,`u_c_W64O125`]" @click="u_c_W64O125_event_DMX517($event)"></a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"infoContent":`1.活动介绍
（1）【成神归来 每日赠礼】
①活动期间，每日通过官网储值任意金额，即可领取首充奖励；
②当日首充奖励需在当日领取完毕，逾期失效，不可补领；

（2）【九考特训 签到送好礼】
①活动期间，每日登入活动页面，即可完成签到，累计签到天数达到1、3、7、12、14天后，即可领取签到奖励；
②每个档位的奖励，每个账号只能领取一次；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


（3）【天使的选择】
①活动期间，通过官网储值日储值满5美金，每日可获得3次机会开启盲盒
②消耗一张抽奖券可以进行对应次数开盲盒，随机获得奖池内奖励
③抽奖券不会进行每天重置，需要在活动期间内进行使用，逾期无效。

（4）【成神祝福赠礼】
①活动期间，在【天使盲盒 】中累计消耗的抽奖券达到一定的数量，可以解锁领取对应的奖励；
②累计消耗数量针对整个活动期间进行统计，不会进行每天重置；
③未领取的奖励可在活动结束后7天内继续领取，7天后失效；


2.奖励发放
奖励将会直接发放至游戏内邮件处，可通过游戏内邮件查收

3.活动最终解释权归《斗罗大陆3D：魂师对决》运营团队所有。`,"copyTipsState":false,"previewPopup":``},"en-US":{"infoContent":`1、1st Top-up Gift
During the event, top up on  official website to obtain a reward. The reward can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

2、Daily Sign-in Reward
Log in to the event page every day to sign in. Sign in for 1/3/5/7 day(s) to claim sign-in rewards.
Each tier of rewards can only be claimed once per account.
Unclaimed rewards will expire 7 days after the event ends.

3、Valentine's Day Pack
① During the event, for every cumulative top-up of $7.99 USD made through any top-up channel on the official website, you will receive 1 Lottery Ticket.
② Each Lottery Ticket can be used for one draw, randomly obtaining rewards from the prize pool. The maximum number of Lottery Tickets that can be obtained per day is 1000.
③ Lottery Tickets will not reset daily and must be used within the event period. Unused Lottery Tickets will expire after the event ends.

4、Bonus Gift
Corresponding rewards will be unlocked when the total number of Lucky Tickets you used reaches a certain amount.
Unclaimed rewards will expire 7 days after the event ends.`,"copyTipsState":false,"previewPopup":``},"ru-RU":{"infoContent":`1 Первый подарок
Во время мероприятия можно получить вознаграждение за пополнение на официальном сайте. Каждый счет может быть вознагражден только один раз.
Срок невостребованного вознаграждения истекает через семь дней после окончания мероприятия.
2 Ежедневное вознаграждение за вход
Войдите на активную страницу каждый день. Войдите 1 / 3 / 5 / 7 дней, чтобы получить вознаграждение за вход.
Каждый счет может быть вознагражден только один раз.
Срок невостребованного вознаграждения истекает через семь дней после окончания мероприятия.
3 Набор ко Дню Святого Валентина
Во время мероприятия, накапливая 7,99 долларов через любой канал пополнения на официальном сайте, вы получите 1 лотерейный билет.
Каждый лотерейный билет может быть использован для одного розыгрыша и случайного получения награды из призового пула. Ежедневно можно получить до 1000 лотерейных билетов.
Лотерея не будет сбрасываться ежедневно и должна использоваться во время мероприятия. Срок действия неиспользованной лотереи истекает после окончания мероприятия.
4 Поощрительные подарки
Когда общее количество счастливых лотерей, которые вы используете, достигает определенного количества, соответствующая награда будет разблокирована.
Срок невостребованного вознаграждения истекает через семь дней после окончания мероприятия.`,"copyTipsState":false,"previewPopup":``},"pt-PT":{"infoContent":`1ª Recompensa de Recarga
Durante o evento, recarregue no site oficial para obter uma recompensa. A recompensa só pode ser reivindicada uma vez por conta.
As recompensas não reclamadas expirarão 7 dias após o término do evento.
2,Daily Sign-in Recompensa
Faça login na página do evento todos os dias para fazer login. Faça login por 1/3/5/7 dia(s) para reivindicar prêmios de login.
Cada nível de recompensas só pode ser reivindicado uma vez por conta.
As recompensas não reclamadas expirarão 7 dias após o término do evento.
3,Pacote de Dia dos Namorados
① Durante o evento, para cada recarga cumulativa de US $7,99 feito através de qualquer canal de recarga no site oficial, você receberá 1 Bilhete de Loteria.
② Cada Bilhete de Lotaria pode ser usado para um sorteio, obtendo aleatoriamente recompensas da premiação. O número máximo de bilhetes de loteria que pode ser obtido por dia é 1000.
① Os bilhetes de loteria não serão redefinidos diariamente e devem ser usados dentro do período do evento. Os bilhetes de loteria não utilizados expirarão após o término do evento.
4,Presente Bónus
As recompensas correspondentes serão desbloqueadas quando o número total de Lucky Tickets que você usou atingir um determinado valor.
As recompensas não reclamadas expirarão 7 dias após o término do evento.`,"copyTipsState":false,"previewPopup":``}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const {
  toClipboard
} = useClipboard();

const showTips = inject("showTips", (txt, code) => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})

const isIosAppWebview = window?.webkit?.messageHandlers?.callSDKMethodWithParameters;

const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: ""
  },
]
const defaultRoleItem = [{
  roleID: "",
  roleName: getLangTxt("selectRole")
}]
const curPlatform = pagePlatform;

const init = () => {
  compData.bindPopupState = false
  compData.bagPopupState = false
  compData.infoPopupState = false
  compData.tipsPopupState = false
  compData.propsPopupState = false
  compData.quanPopupState = false
  compData.seeGiftPopupState = false
  compData.giftCodePopupState = false
  compData.previewPopup = "";

  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)

}

init()

watch(
  () => pageData.isLogin,
  async (value) => {
    if (!value) return
    await initServerList()
    initLinkServer()
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value || !value.sid) return
    await initRoleList()
    initLinkRole()
  }
)

const initServerList = async () => {
  pageData.serverList = []
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'listServerNew'))
  if (res.result == 1) {
    res?.data?.all_servers ?
      pageData.serverList.push(...res.data.all_servers) :
      "";
    res?.data?.recent_servers ?
      pageData.recentServerList.push(...res.data.recent_servers) :
      "";
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'getMobileGameRole'), {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const bindRole = async () => {
  let res = await request.getJSON(utils.getActivityApi(pagePlatform, pageData.pageId, 'bind'), {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
      server_sid: pageData.serverItem.id,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(
        encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)
      ),
      server_name: pageData.serverItem.sname,
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.serverName = res.data.bind_data.server_name
    pageData.roleName = res.data.bind_data.role_name
    pageData.bindPopupState = false
    pageData.isBind = true
    try {
      window.__updatePointUploadCookie(
        "role_id",
        res.data.bind_data.role_id
      )
      window.__updatePointUploadCookie(
        "role_name",
        res.data.bind_data.role_name
      )
      window.__updatePointUploadCookie(
        "server_id",
        res.data.bind_data.server_id
      )
    } catch (error) {}
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
}

watch(() => compData.copyTipsState, value => {
  if (value) {
    setTimeout(() => {
      compData.copyTipsState = false;
    }, 2000)
  }
});
      // 绑定弹窗的click事件
      const u_c_YLOM18_event_F8M123= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_EZ8J19_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_DKO437_event_QSVC19= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
  alert(getLangTxt("selectServer"))
  return
}
if (!pageData.roleIndex) {
  alert(getLangTxt("selectRole"))
  return
}
if (!canClickBindSubmit.value) return
canClickBindSubmit.value = false
await bindRole()
canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_4AAC40_event_DMX517= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗的click事件
      const u_c_B7PH41_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_37AZ42_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 查看的click事件
      const u_c_7LGZ59_event_1JVM17= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 复制并前往的click事件
      const u_c_6YH561_event_QX7K17= async (e,code)=>{
        try {try {
  await toClipboard(code);
} catch (e) {}

bridge.open(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_207I64_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 提示语弹窗的click事件
      const u_c_9Z7B65_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_F5DD66_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_CV5E69_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_8L7W71_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 查看奖励弹窗的click事件
      const u_c_VRJF72_event_TETB35= async (e)=>{
        try {pageData.seeGiftPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_6HXR73_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_A47S77_event_DMX517= async (e)=>{
        try {pageData.seeGiftPopupState = false} catch (error) {console.log(error)}
      };
      // 道具领取成功弹窗的click事件
      const u_c_5CEN78_event_TETB35= async (e)=>{
        try {pageData.propsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_B8SU79_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_AYE286_event_YU9U68= async (e)=>{
        try {pageData.propsPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_612G89_event_DMX517= async (e)=>{
        try {pageData.propsPopupState = false} catch (error) {console.log(error)}
      };
      // 优惠券领取成功弹窗的click事件
      const u_c_6QX790_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_D5F091_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_XNP598_event_35V252= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_WXSX105_event_DMX517= async (e)=>{
        try {pageData.quanPopupState = false} catch (error) {console.log(error)}
      };
      // 序列号领取成功弹窗的click事件
      const u_c_1RDB106_event_TXZS38= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_3KAF107_event_EKU139= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_AWGX113_event_QX7K17= async (e)=>{
        try {await toClipboard(pageData.curGiftName);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_08YN117_event_KBHJ41= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 前往兑换的click事件
      const u_c_9GXE118_event_YU9U68= async (e)=>{
        try {try {
  await toClipboard(pageData.curGiftName);
  compData.copyTipsState = true;
  await utils.sleep(1)
} catch (e) {}

bridge.open(pageData.exchangeLink)} catch (error) {console.log(error)}
      };
      // 活动规则弹窗的click事件
      const u_c_B8W2120_event_TETB35= async (e)=>{
        try {pageData.infoPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_85YY121_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_W64O125_event_DMX517= async (e)=>{
        try {pageData.infoPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:38.85vw;
height:28.65vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521015-20.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521040-51.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:38.85vw;
height:40.31vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521003-65.jpeg);
position:relative;
box-sizing:border-box;
padding:1.56vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:11.88vw;
height:4.17vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520924-66.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#ffffff;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#ffffff;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.default{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.default{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.default{
.u_c_DCJ823.normal{
position:relative;

}
}.default{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_0BRZ33.normal{
position:relative;

}
}.default{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.default{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.default{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.default{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.default{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_7SYQ47.normal{
position:relative;

}
}.default{
.u_c_DR2P48.normal{
position:relative;

}
}.default{
.u_c_4DR950.normal{
position:relative;

}
}.default{
.u_c_3MAG52.normal{
position:relative;

}
}.default{
.u_c_V45S53.normal{
position:relative;

}
}.default{
.u_c_6VDD54.normal{
position:relative;

}
}.default{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_0P5L58.normal{
position:relative;

}
}.default{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.default{
.u_c_6YH561.normal{
position:relative;

}
}.default{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.default{
.u_c_9Z7B65.normal{
position:relative;

}
}.default{
.u_c_F5DD66.normal{
position:relative;

}
}.default{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.default{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.default{
.u_c_VRJF72.normal{
position:relative;

}
}.default{
.u_c_6HXR73.normal{
position:relative;

}
}.default{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:6.15vw;
text-align:center;
line-height:150%;

}
}.default{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.default{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.default{
.u_c_PR8033.normal{
position:relative;

}
}.default{
.u_c_CZYQ34.normal{
position:relative;

}
}.default{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.default{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.default{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.default{
.u_c_NWC738.normal{
position:relative;

}
}.default{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.default{
.u_c_5CEN78.normal{
position:relative;

}
}.default{
.u_c_B8SU79.normal{
position:relative;

}
}.default{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.default{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_3XQE83.normal{
position:relative;

}
}.default{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.default{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.default{
.u_c_6QX790.normal{
position:relative;

}
}.default{
.u_c_D5F091.normal{
position:relative;

}
}.default{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.default{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.default{
.u_c_5JF295.normal{
position:relative;

}
}.default{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.default{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.default{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_3KAF107.normal{
position:relative;

}
}.default{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.default{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.default{
.u_c_29SD111.normal{
position:relative;
display:flex;
justifi-content:center;
align-items:center;

}
}.default{
.u_c_Z45Y23.normal{
position:relative;

}
}.default{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.default{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.default{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.default{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.default{
.u_c_B8W2120.normal{
position:relative;

}
}.default{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.default{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.default{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.en-US{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:38.85vw;
height:28.65vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521015-20.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521040-51.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:38.85vw;
height:40.31vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521003-65.jpeg);
position:relative;
box-sizing:border-box;
padding:1.56vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:11.88vw;
height:4.17vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520924-66.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#ffffff;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#ffffff;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.en-US{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.en-US{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.en-US{
.u_c_DCJ823.normal{
position:relative;

}
}.en-US{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_0BRZ33.normal{
position:relative;

}
}.en-US{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.en-US{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.en-US{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.en-US{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.en-US{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_7SYQ47.normal{
position:relative;

}
}.en-US{
.u_c_DR2P48.normal{
position:relative;

}
}.en-US{
.u_c_4DR950.normal{
position:relative;

}
}.en-US{
.u_c_3MAG52.normal{
position:relative;

}
}.en-US{
.u_c_V45S53.normal{
position:relative;

}
}.en-US{
.u_c_6VDD54.normal{
position:relative;

}
}.en-US{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_0P5L58.normal{
position:relative;

}
}.en-US{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.en-US{
.u_c_6YH561.normal{
position:relative;

}
}.en-US{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.en-US{
.u_c_9Z7B65.normal{
position:relative;

}
}.en-US{
.u_c_F5DD66.normal{
position:relative;

}
}.en-US{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.en-US{
.u_c_VRJF72.normal{
position:relative;

}
}.en-US{
.u_c_6HXR73.normal{
position:relative;

}
}.en-US{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:6.15vw;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.en-US{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.en-US{
.u_c_PR8033.normal{
position:relative;

}
}.en-US{
.u_c_CZYQ34.normal{
position:relative;

}
}.en-US{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.en-US{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.en-US{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.en-US{
.u_c_NWC738.normal{
position:relative;

}
}.en-US{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.en-US{
.u_c_5CEN78.normal{
position:relative;

}
}.en-US{
.u_c_B8SU79.normal{
position:relative;

}
}.en-US{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.en-US{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_3XQE83.normal{
position:relative;

}
}.en-US{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.en-US{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.en-US{
.u_c_6QX790.normal{
position:relative;

}
}.en-US{
.u_c_D5F091.normal{
position:relative;

}
}.en-US{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.en-US{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.en-US{
.u_c_5JF295.normal{
position:relative;

}
}.en-US{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.en-US{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_3KAF107.normal{
position:relative;

}
}.en-US{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.en-US{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.en-US{
.u_c_29SD111.normal{
position:relative;
display:flex;
justifi-content:center;
align-items:center;

}
}.en-US{
.u_c_Z45Y23.normal{
position:relative;

}
}.en-US{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.en-US{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.en-US{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.en-US{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.en-US{
.u_c_B8W2120.normal{
position:relative;

}
}.en-US{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.en-US{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.en-US{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.ru-RU{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:38.85vw;
height:28.65vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521015-20.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521040-51.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:38.85vw;
height:40.31vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521003-65.jpeg);
position:relative;
box-sizing:border-box;
padding:1.56vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:11.88vw;
height:4.17vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520924-66.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#ffffff;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#ffffff;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.ru-RU{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.ru-RU{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.ru-RU{
.u_c_DCJ823.normal{
position:relative;

}
}.ru-RU{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_0BRZ33.normal{
position:relative;

}
}.ru-RU{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.ru-RU{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.ru-RU{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.ru-RU{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.ru-RU{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_7SYQ47.normal{
position:relative;

}
}.ru-RU{
.u_c_DR2P48.normal{
position:relative;

}
}.ru-RU{
.u_c_4DR950.normal{
position:relative;

}
}.ru-RU{
.u_c_3MAG52.normal{
position:relative;

}
}.ru-RU{
.u_c_V45S53.normal{
position:relative;

}
}.ru-RU{
.u_c_6VDD54.normal{
position:relative;

}
}.ru-RU{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_0P5L58.normal{
position:relative;

}
}.ru-RU{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.ru-RU{
.u_c_6YH561.normal{
position:relative;

}
}.ru-RU{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.ru-RU{
.u_c_9Z7B65.normal{
position:relative;

}
}.ru-RU{
.u_c_F5DD66.normal{
position:relative;

}
}.ru-RU{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ru-RU{
.u_c_VRJF72.normal{
position:relative;

}
}.ru-RU{
.u_c_6HXR73.normal{
position:relative;

}
}.ru-RU{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:6.15vw;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.ru-RU{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ru-RU{
.u_c_PR8033.normal{
position:relative;

}
}.ru-RU{
.u_c_CZYQ34.normal{
position:relative;

}
}.ru-RU{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.ru-RU{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.ru-RU{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ru-RU{
.u_c_NWC738.normal{
position:relative;

}
}.ru-RU{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.ru-RU{
.u_c_5CEN78.normal{
position:relative;

}
}.ru-RU{
.u_c_B8SU79.normal{
position:relative;

}
}.ru-RU{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.ru-RU{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ru-RU{
.u_c_3XQE83.normal{
position:relative;

}
}.ru-RU{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.ru-RU{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.ru-RU{
.u_c_6QX790.normal{
position:relative;

}
}.ru-RU{
.u_c_D5F091.normal{
position:relative;

}
}.ru-RU{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.ru-RU{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.ru-RU{
.u_c_5JF295.normal{
position:relative;

}
}.ru-RU{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.ru-RU{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_3KAF107.normal{
position:relative;

}
}.ru-RU{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.ru-RU{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.ru-RU{
.u_c_29SD111.normal{
position:relative;
display:flex;
justifi-content:center;
align-items:center;

}
}.ru-RU{
.u_c_Z45Y23.normal{
position:relative;

}
}.ru-RU{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.ru-RU{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.ru-RU{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.ru-RU{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.ru-RU{
.u_c_B8W2120.normal{
position:relative;

}
}.ru-RU{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.ru-RU{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.ru-RU{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}.pt-PT{
.u_c_3AAA17.normal{
position:relative;
z-index:100;

}

.u_c_3AAA17.normal .popup{
position:fixed;
top:0;
left:0;
width:100%;
height:100%;
background-color:rgba(0,0,0,0.6);
z-index:99;
display:flex;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-content-small{
width:38.85vw;
height:28.65vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521015-20.jpeg);
position:relative;
box-sizing:border-box;
padding:1.04vw 2.08vw;

}

.u_c_3AAA17.normal .popup-close{
width:2.08vw;
height:2.08vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521040-51.png);

}

.u_c_3AAA17.normal .popup-title{
font-size:1.88vw;
text-align:center;

}

.u_c_3AAA17.normal .popup-content-big{
width:38.85vw;
height:40.31vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919521003-65.jpeg);
position:relative;
box-sizing:border-box;
padding:1.56vw 2.08vw;

}

.u_c_3AAA17.normal .sure{
display:flex;
width:11.88vw;
height:4.17vw;
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/03/1710919520924-66.jpeg);
font-size:1.25vw;
color:#ffffff;
text-decoration:none;
justify-content:center;
align-items:center;

}

.u_c_3AAA17.normal .popup-title-color{
color:#ffffff;

}

.u_c_3AAA17.normal .txt-size{
font-size:1.15vw;

}

.u_c_3AAA17.normal .txt-color{
color:#ffffff;

}

.u_c_3AAA17.normal .tips-color{
color:red;

}

.u_c_3AAA17.normal .border-color{
border:1px solid;
border-color:#c1b19b;

}
}.pt-PT{
.u_c_YLOM18.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_EZ8J19.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DDUR20.normal{
position:relative;
margin-top:5.47vw;

}
}.pt-PT{
.u_c_B11P22.normal{
position:relative;
margin:auto;
margin-top:1.30vw;
text-align:center;
font-size:0;

}

.u_c_B11P22.normal .select-item{
margin-bottom:1.04vw;

}

.u_c_B11P22.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170926122425323538.jpg);
width:26.82vw;
height:4.17vw;
font-size:1.04vw;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:1.04vw;
color:#333;

}
}.pt-PT{
.u_c_DCJ823.normal{
position:relative;

}
}.pt-PT{
.u_c_9I0S24.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_YB6125.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_5WSH27.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DI5W28.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DTZ430.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_BL6L31.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_0BRZ33.normal{
position:relative;

}
}.pt-PT{
.u_c_6MFN34.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_X5WC35.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_DKO437.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_784339.normal{
position:relative;
margin-top:0.52vw;
text-align:center;

}
}.pt-PT{
.u_c_4AAC40.normal{
position:absolute;
top:2.71vw;
right:2.24vw;

}
}.pt-PT{
.u_c_B7PH41.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_37AZ42.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_YV9L43.normal{
position:relative;
margin-top:5.63vw;

}
}.pt-PT{
.u_c_AJEN45.normal{
position:relative;
height:26.82vw;
overflow-y:auto;
margin-top:0.57vw;

}
}.pt-PT{
.u_c_FFLM46.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_FFLM46.normal .th{
border-left:none;
padding:0.73vw 0;
border-top:none;
font-weight:bold;

}

.u_c_FFLM46.normal .th:last-child{
border-right:none;

}

.u_c_FFLM46.normal .td{
border-left:none;
padding:0.52vw;
border-top:none;
border-bottom:none;

}

.u_c_FFLM46.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_FFLM46.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_7SYQ47.normal{
position:relative;

}
}.pt-PT{
.u_c_DR2P48.normal{
position:relative;

}
}.pt-PT{
.u_c_4DR950.normal{
position:relative;

}
}.pt-PT{
.u_c_3MAG52.normal{
position:relative;

}
}.pt-PT{
.u_c_V45S53.normal{
position:relative;

}
}.pt-PT{
.u_c_6VDD54.normal{
position:relative;

}
}.pt-PT{
.u_c_5EJF56.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_EGHL57.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_0P5L58.normal{
position:relative;

}
}.pt-PT{
.u_c_7LGZ59.normal{
position:relative;
color:#ffac00;

}
}.pt-PT{
.u_c_6YH561.normal{
position:relative;

}
}.pt-PT{
.u_c_A18C63.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_207I64.normal{
position:absolute;
top:2.66vw;
right:2.40vw;

}
}.pt-PT{
.u_c_9Z7B65.normal{
position:relative;

}
}.pt-PT{
.u_c_F5DD66.normal{
position:relative;

}
}.pt-PT{
.u_c_V98X67.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:10.21vw;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_CV5E69.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_8L7W71.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.pt-PT{
.u_c_VRJF72.normal{
position:relative;

}
}.pt-PT{
.u_c_6HXR73.normal{
position:relative;

}
}.pt-PT{
.u_c_UORR74.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:6.15vw;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_8KE031.normal{
position:relative;
box-sizing:border-box;
padding:0 2.08vw;
overflow-y:auto;
margin-top:0.89vw;
text-align:center;
line-height:150%;
height:16.46vw;
white-space:pre-line;

}
}.pt-PT{
.u_c_87FO32.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pt-PT{
.u_c_PR8033.normal{
position:relative;

}
}.pt-PT{
.u_c_CZYQ34.normal{
position:relative;

}
}.pt-PT{
.u_c_EDXO35.normal{
position:relative;
padding:1.04vw;
width:30%;

}
}.pt-PT{
.u_c_BVS636.normal{
position:relative;
width:60%;

}
}.pt-PT{
.u_c_NLX637.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pt-PT{
.u_c_NWC738.normal{
position:relative;

}
}.pt-PT{
.u_c_A47S77.normal{
position:absolute;
top:2.60vw;
right:2.34vw;

}
}.pt-PT{
.u_c_5CEN78.normal{
position:relative;

}
}.pt-PT{
.u_c_B8SU79.normal{
position:relative;

}
}.pt-PT{
.u_c_DY3E80.normal{
position:relative;
margin-top:6.35vw;

}
}.pt-PT{
.u_c_1U1082.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.pt-PT{
.u_c_3XQE83.normal{
position:relative;

}
}.pt-PT{
.u_c_F0U284.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_Z47085.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_AYE286.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_AY1I88.normal{
position:relative;
margin-top:0.83vw;
text-align:center;

}
}.pt-PT{
.u_c_612G89.normal{
position:absolute;
top:2.66vw;
right:2.34vw;

}
}.pt-PT{
.u_c_6QX790.normal{
position:relative;

}
}.pt-PT{
.u_c_D5F091.normal{
position:relative;

}
}.pt-PT{
.u_c_60LO92.normal{
position:relative;
margin-top:6.46vw;

}
}.pt-PT{
.u_c_XYU694.normal{
position:relative;
height:17.76vw;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.52vw;

}
}.pt-PT{
.u_c_5JF295.normal{
position:relative;

}
}.pt-PT{
.u_c_EQXC96.normal{
position:relative;
margin-top:0.26vw;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_V4J897.normal{
position:relative;
display:block;
margin:auto;
margin-top:1.56vw;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_XNP598.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_WXSX105.normal{
position:absolute;
top:2.55vw;
right:2.24vw;

}
}.pt-PT{
.u_c_1RDB106.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_3KAF107.normal{
position:relative;

}
}.pt-PT{
.u_c_C3XY108.normal{
position:relative;
margin-top:6.35vw;

}
}.pt-PT{
.u_c_4L93110.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:1.09vw;

}
}.pt-PT{
.u_c_29SD111.normal{
position:relative;
display:flex;
justifi-content:center;
align-items:center;

}
}.pt-PT{
.u_c_Z45Y23.normal{
position:relative;

}
}.pt-PT{
.u_c_AWGX113.normal{
position:relative;
margin-left:1.56vw;
display:none;

}
}.pt-PT{
.u_c_237H115.normal{
position:relative;
margin-top:1.56vw;
text-align:center;

}

.u_c_237H115.normal.hide{
opacity:0;

}
}.pt-PT{
.u_c_08YN117.normal{
position:absolute;
top:2.55vw;
right:2.19vw;

}
}.pt-PT{
.u_c_9GXE118.normal{
position:relative;
margin:auto;
margin-top:1.04vw;

}
}.pt-PT{
.u_c_B8W2120.normal{
position:relative;

}
}.pt-PT{
.u_c_85YY121.normal{
position:relative;
width:10.42vw;
height:5.21vw;

}
}.pt-PT{
.u_c_CU24122.normal{
position:relative;
margin-top:5.89vw;

}
}.pt-PT{
.u_c_8739124.normal{
position:relative;
box-sizing:border-box;
height:26.46vw;
padding:0 2.08vw;
overflow-y:auto;
margin-top:1.35vw;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_W64O125.normal{
position:absolute;
top:2.66vw;
right:2.24vw;

}
}
</style>
